const logout = () => {
    sessionStorage.removeItem("Name");
    sessionStorage.removeItem("LoggedIn");
    window.location.href = '/';
}

export default logout;